import { Injectable } from '@angular/core';
import { DataService, PersistenceService } from '@barthauer/abc/core/data';
import { ErrorInfo } from '@barthauer/abc/core/error-handling';
import { ResourceManager } from '@barthauer/abc/core/resources';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DocumentsEditorsService {
  private closeDialogSubject = new Subject<any>();
  private updateDataSubject = new Subject<any>();
  public notificationSubject: Subject<any> = new Subject();
  public notification$ = this.notificationSubject.asObservable();
  public updateData$ = this.updateDataSubject.asObservable();
  public closeDialog$ = this.closeDialogSubject.asObservable();
  public refreshDocumentList: Subject<any> = new Subject();
  public persistenceCategory = 'DocumentsEditorCardComponent';
  private res = ResourceManager.getResources('abc-common-editors-documents');

  callUpdateDataSubject(data?) {
    this.updateDataSubject.next(data);
  }

  callCloseDialogSubject() {
    this.closeDialogSubject.next();
  }

  constructor(private persistenceService: PersistenceService, private coreDataService: DataService) {
    this.persistenceService.afterPersistPendingChanges$.subscribe({
      next: (object) => {
        if (object instanceof ErrorInfo) {
          // if (object.isWarning) this.notificationSubject.next({ type: ToastType.Warning, message: object.message });
          // else this.notificationSubject.next({ type: ToastType.Error, message: object.message });
        } else if (object?.find((_) => _.persistenceCategory === this.persistenceCategory)) {
          this.updateDataSubject.next();
          this.refreshDocumentList.next();
        }
      },
    });
  }

  public callPersistPendingChanges() {
    this.persistenceService.persistPendingChanges(this.persistenceCategory);
  }

  public getFileType(fileName: string, value?: boolean) {
    const extension = fileName?.split('.').pop().toLowerCase();
    if (documents.includes(extension)) {
      return value ? 'DOC' : 'Dokument';
    } else if (images.includes(extension)) {
      return value ? 'IMAGE' : 'Bild';
    } else {
      return value ? 'FILE' : 'Datei';
    }
  }

  public readFile(fileName): Observable<Blob> {
    const query = {
      Path: fileName,
      OutputType: 'BinaryStream',
    };
    return this.coreDataService.executeReadFileQueryBlob(query, true);
  }

  public readFilePath(fileName): Observable<string> {
    const query = {
      Path: fileName,
      OutputType: 'Path',
    };
    return this.coreDataService.executeReadFileQuery(query, true).pipe(
      map((path) => {
        return <string>(<unknown>path);
      })
    );
  }
}

export const documents: Array<string> = ['xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx', 'txt'];
export const images: Array<string> = ['jpg', 'jpeg', 'png'];
